<template>
  <div class="w-full">
    <vx-card
      class="contactar overflow-hidden"
      @click="
        (contatoSelected = { id: null, contato: null, nome: null, tipo: null }),
          (contatosCliente = []),
          getContatos(),
          (osModal = true)
      "
    >
      <template slot="no-body">
        <div class="item-details px-2">
          <div class="my-1">
            <vs-col
              class="p-5"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <span>
                <vs-icon color="primary" icon="contacts" size="30px"></vs-icon>
              </span>
            </vs-col>
            <vs-col
              class
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <span class="py-2" style="font-size: 18px; text-align: center"
                >CONTATOS</span
              >
            </vs-col>
          </div>
        </div>
      </template>
    </vx-card>

    <vs-popup
      ref="popupContatos"
      :active.sync="osModal"
      :title="'CONTATOS: ' + item.nomeCliente"
      class="modal-contatos"
    >
      <div id="contactar" class="vs-con-loading__container w-full">
        <div v-if="loading" style="padding: 16px 0; min-height: 200px;">
          <!-- Skeleton: action buttons row -->
          <div style="display: flex; gap: 8px; margin-bottom: 16px;">
            <div class="sk-pulse" style="height: 36px; flex: 1; border-radius: 6px;"></div>
            <div class="sk-pulse" style="height: 36px; flex: 1; border-radius: 6px;"></div>
          </div>
          <!-- Skeleton: contact cards -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div v-for="n in 4" :key="n" class="sk-pulse" style="height: 72px; border-radius: 8px;"></div>
          </div>
          <!-- Skeleton: template select -->
          <div style="margin-top: 16px;">
            <div class="sk-pulse" style="height: 12px; width: 140px; border-radius: 4px; margin-bottom: 8px;"></div>
            <div class="sk-pulse" style="height: 38px; border-radius: 6px;"></div>
          </div>
          <!-- Skeleton: contactar button -->
          <div class="sk-pulse" style="height: 40px; border-radius: 6px; margin-top: 16px;"></div>
        </div>
        <div v-else-if="!contatosCliente.length > 0">
          <div class="con-colors mt-10 mb-20">
            <ul>
              <span
                class="px-3 pt-2"
                style="color: grey !important; font-weight: 1000 !important"
                ><vs-icon icon="sentiment_dissatisfied" size="large"></vs-icon
              ></span>
            </ul>
          </div>
        </div>
        <div v-else>
          <div class="contactar-modal-layout">
            <div class="contactar-modal-scroll" @wheel.prevent="onModalWheel">
              <div class="acoes-contato-topo mb-2">
                <div class="acoes-contato-topo__titulo">
                  Ações de contato
                </div>
                <vs-row vs-type="flex" vs-justify="space-between">
                  <vs-col vs-w="6" class="p-1">
                    <vs-button
                      class="w-full"
                      size="small"
                      color="warning"
                      type="filled"
                      :disabled="!canEditarContatoSelecionado"
                      @click="abrirEdicaoContato()"
                    >
                      Editar contato
                    </vs-button>
                  </vs-col>
                  <vs-col vs-w="6" class="p-1">
                    <vs-button
                      class="w-full"
                      size="small"
                      color="success"
                      type="filled"
                      :disabled="!canSelecionarContatoConfirmacao"
                      @click="abrirConfirmacaoAcao()"
                    >
                      Definir confirmação
                    </vs-button>
                  </vs-col>
                </vs-row>
              </div>

              <vs-row class="mb-3" type="flex" vs-justify="flex-start">
                <vs-col
                  v-for="(contato, index) in contatosCliente"
                  :key="index"
                  class="p-1 contato-col"
                  vs-align="flex-start"
                  vs-justify="flex-start"
                  vs-type="flex"
                  vs-w="6"
                  @click.native="
                    contato.lixeira > 0 ? null : selectContato(contato)
                  "
                >
                  <div
                    :class="[
                      'contato-card',
                      contato.id == contatoSelected.id
                        ? 'contato-card--ativo'
                        : '',
                      contato.lixeira > 0 ? 'contato-card--deletado' : '',
                      idContatoConfirmacao && contato.id == idContatoConfirmacao
                        ? 'contato-card--confirmacao'
                        : '',
                    ]"
                  >
                    <div
                      v-if="
                        idContatoConfirmacao &&
                        contato.id == idContatoConfirmacao
                      "
                      class="confirmacao-badge"
                    >
                      <vs-icon icon="star" size="10px" />
                      Contato de confirmação
                    </div>

                    <div class="contato-card-icon">
                      <vs-icon
                        :icon="contato.tipo == 1 ? 'alternate_email' : 'phone'"
                        size="16px"
                        :color="contato.lixeira > 0 ? 'white' : 'dark'"
                      />
                    </div>

                    <div class="contato-card-nome">{{ contato.nome }}</div>
                    <div class="contato-card-contato">
                      {{ contato.contato }}
                    </div>
                  </div>
                </vs-col>
              </vs-row>

            </div>

            <vs-row class="mb-3 px-2">
              <vs-col vs-w="12">
                <div class="w-full">
                  <label class="text-sm mb-1 block" style="font-weight: 500;">Template de Mensagem</label>
                  <el-select
                    v-model="templateSelecionadoId"
                    class="w-full"
                    size="small"
                    placeholder="Selecione um template..."
                    :popper-append-to-body="true"
                    popper-class="popper-select-template"
                  >
                    <el-option
                      v-for="tpl in watiTemplates"
                      :key="tpl.id"
                      :value="tpl.id"
                      :label="tpl.elementName"
                    ></el-option>
                  </el-select>
                </div>
              </vs-col>
            </vs-row>

            <div class="contactar-modal-footer">
              <vs-button
                :disabled="
                  contatoSelected.contato == null ||
                  contatoSelected.tipo == 1 ||
                  !templateSelecionadoId
                "
                class="w-full"
                color="success"
                size="sm"
                type="relief"
                @click="contactar()"
                >Contactar
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      ref="popupEditarContato"
      :active.sync="editarContatoModal"
      title="Editar contato"
      class="modal-editar-contato"
    >
      <div class="w-full">
        <vs-input
          v-model="contatoEdicao.nome"
          class="w-full mb-3"
          color="dark"
          label="Nome"
        />
        <vs-input
          v-model="contatoEdicao.contato"
          class="w-full mb-3"
          color="dark"
          label="Contato"
          @input="onContatoInput"
        />
        <el-select
          v-model="contatoEdicao.tipo"
          class="w-full"
          size="small"
          placeholder="Tipo"
          :popper-append-to-body="true"
          popper-class="popper-editar-contato"
        >
          <el-option
            v-for="tipoContato in tiposContatoEdicao"
            :key="tipoContato.value"
            :value="tipoContato.value"
            :label="tipoContato.label"
          ></el-option>
        </el-select>

        <vs-row class="mt-3" vs-type="flex" vs-justify="flex-end">
          <vs-button
            size="small"
            color="success"
            :disabled="!canSalvarContatoEditado"
            @click="salvarEdicaoContato()"
          >
            Salvar
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
      ref="popupConfirmacao"
      :active.sync="modalConfirmacaoAcao"
      :title="confirmacaoAcao.titulo"
      class="modal-confirmacao-contato"
    >
      <div class="w-full">
        <p class="confirmacao-texto">{{ confirmacaoAcao.texto }}</p>
        <vs-row class="mt-3" vs-type="flex" vs-justify="flex-end">
          <vs-button
            class="mr-2"
            color="dark"
            type="border"
            size="small"
            @click="modalConfirmacaoAcao = false"
          >
            Cancelar
          </vs-button>
          <vs-button
            color="success"
            type="filled"
            size="small"
            @click="confirmarAcaoContato()"
          >
            Confirmar
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>

export default {
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {
      osModal: false,
      loading: false,
      contatosCliente: [],
      contatoSelected: { id: null, contato: null, nome: null, tipo: null },
      idContatoConfirmacao: null,
      watiTemplates: [],
      templateSelecionadoId: null,

      editarContatoModal: false,
      contatoEdicao: {
        id: null,
        nome: "",
        contato: "",
        tipo: "2",
        id_setor: null,
      },

      tiposContatoEdicao: [
        { value: "1", label: "E-mail" },
        { value: "2", label: "Telefone" },
      ],

      modalConfirmacaoAcao: false,
      confirmacaoAcao: {
        tipo: null,
        titulo: "Confirmar ação",
        texto: "",
      },
    };
  },
  computed: {
    canSelecionarContatoConfirmacao() {
      return (
        this.item.id_contrato &&
        this.item.id_contrato > 0 &&
        this.contatoSelected &&
        this.contatoSelected.id > 0 &&
        !(this.contatoSelected.lixeira > 0)
      );
    },
    canEditarContatoSelecionado() {
      return (
        this.contatoSelected &&
        this.contatoSelected.id > 0 &&
        !(this.contatoSelected.lixeira > 0)
      );
    },
    canSalvarContatoEditado() {
      return (
        this.contatoEdicao.id > 0 &&
        this.contatoEdicao.nome &&
        this.contatoEdicao.nome.trim().length > 0 &&
        this.contatoEdicao.contato &&
        this.contatoEdicao.contato.trim().length > 0
      );
    },
  },
  watch: {
    osModal(novoValor) {
      this.ajustarZIndexPopups();
      if (!novoValor) {
        this.$emit("fechar-pai");
      }
    },
    editarContatoModal() {
      this.ajustarZIndexPopups();
    },
    modalConfirmacaoAcao() {
      this.ajustarZIndexPopups();
    },
    "contatoEdicao.tipo": function (newTipo) {
      if (newTipo === "2") {
        this.onContatoInput(this.contatoEdicao.contato);
      } else {
        this.contatoEdicao.contato = this.contatoEdicao.contato.replace(/[()-\s]/g, "");
      }
    },
  },
  mounted() {
    this.ajustarZIndexPopups();
  },
  methods: {
    ajustarZIndexPopups() {
      this.$nextTick(function () {
        var self = this;
        var setZ = function (refName, zIndex) {
          var popup = self.$refs[refName];
          var el = popup && popup.$refs && popup.$refs.con;
          if (el) {
            el.style.zIndex = String(zIndex);
          }
        };

        setZ("popupContatos", 62000);
        if (self.editarContatoModal) {
          setZ("popupEditarContato", 64000);
        }
        if (self.modalConfirmacaoAcao) {
          setZ("popupConfirmacao", 65000);
        }
      });
    },
    onModalWheel(event) {
      var container = event.currentTarget;
      if (!container) return;
      container.scrollTop += event.deltaY;
    },

    normalizarTelefoneWati(contato) {
      if (Number(contato.tipo) !== 2) return "";
      var normalizado = String(contato.contato).replace(/\D/g, "");
      if (normalizado.length === 8 || normalizado.length === 9) {
        normalizado = "92" + normalizado;
      }
      if (!normalizado.startsWith("55")) normalizado = "55" + normalizado;
      if (normalizado.length == 13 && normalizado[4] == "9") {
        normalizado = normalizado.slice(0, 4) + normalizado.slice(5);
      }
      return normalizado;
    },

    async getContatos() {
      this.loading = true;
      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        var contatosApi = await this.$http.get(
          "contatoCliente/" + this.item.id_cliente
        );
        await this.getWatiTemplates();

        var self = this;
        this.contatosCliente = (contatosApi || [])
          .filter(function (contato) {
            return Number(contato.lixeira || 0) === 0;
          })
          .map(function (contato) {
            return Object.assign({}, contato, {
              tipo: self.normalizarTipoContato(contato.tipo),
              numeroWati: self.normalizarTelefoneWati(contato),
            });
          });

        this.idContatoConfirmacao =
          this.item.id_contato_confirmacao || null;
      } catch (err) {
        var error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.loading = false;
        await this.$vs.loading.close("#contactar > .con-vs-loading");
      }
    },
    async getWatiTemplates() {
      try {
        var url = "getWatiTemplates?filtro[status][]=approved";
        var res = await this.$http.get(url);
        if (res && res.data) {
          this.watiTemplates = res.data;
        }
      } catch (err) {
        var errorMsg = "Erro ao buscar templates";
        if (
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          errorMsg = err.response.data.message;
        }
        this.$vs.notify({
          title: "Erro",
          text: errorMsg,
          color: "danger",
        });
      }
    },
    abrirConfirmacaoAcao() {
      if (!this.canSelecionarContatoConfirmacao) {
        return;
      }
      this.confirmacaoAcao.tipo = "definir";
      this.confirmacaoAcao.titulo = "Confirmar ação";
      this.confirmacaoAcao.texto =
        "Tem certeza que deseja definir este contato como contato de confirmação?";
      this.modalConfirmacaoAcao = true;
    },
    async confirmarAcaoContato() {
      this.modalConfirmacaoAcao = false;
      await this.definirContatoConfirmacao();
    },
    async definirContatoConfirmacao() {
      if (!this.canSelecionarContatoConfirmacao) {
        return;
      }

      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        await this.$http.put("contrato/" + this.item.id_contrato, {
          id_contato_confirmacao: this.contatoSelected.id,
        });

        this.idContatoConfirmacao = this.contatoSelected.id;
        this.$emit("confirmacao-atualizada", {
          idContrato: this.item.id_contrato,
          idContatoConfirmacao: this.contatoSelected.id,
          nomeContatoConfirmacao: this.contatoSelected.nome,
          contatoConfirmacao: this.contatoSelected.contato,
        });

        await this.$vs.notify({
          title: "Sucesso",
          text: "Contato de confirmação atualizado.",
          color: "success",
        });
      } catch (err) {
        var error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#contactar > .con-vs-loading");
    },
    onContatoInput(val) {
      if (this.contatoEdicao.tipo === "2") {
        var x = val.replace(/\D/g, "");
        if (x.length > 11) {
          x = x.slice(0, 11);
        }
        if (x.length <= 10) {
          this.contatoEdicao.contato = x
            .replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
            .replace(/^(\d{2})(\d{4})(\d)/, "($1) $2-$3")
            .replace(/^(\d{2})(\d)/, "($1) $2")
            .replace(/^(\d)/, "($1");
        } else {
          this.contatoEdicao.contato = x
            .replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
            .replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3")
            .replace(/^(\d{2})(\d)/, "($1) $2")
            .replace(/^(\d)/, "($1");
        }
      }
    },
    async abrirEdicaoContato() {
      if (!this.canEditarContatoSelecionado) {
        return;
      }

      this.contatoEdicao = {
        id: this.contatoSelected.id,
        nome: this.contatoSelected.nome || "",
        contato: this.contatoSelected.contato || "",
        tipo: this.normalizarTipoContato(this.contatoSelected.tipo),
        id_setor: this.contatoSelected.id_setor || null,
      };

      if (this.contatoEdicao.tipo === "2") {
        this.onContatoInput(this.contatoEdicao.contato);
      }
      this.editarContatoModal = true;
    },
    async salvarEdicaoContato() {
      if (!this.canSalvarContatoEditado) {
        return;
      }

      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        await this.$http.put("contato/" + this.contatoEdicao.id, {
          nome: this.contatoEdicao.nome,
          contato: this.contatoEdicao.contato,
          tipo: Number(this.contatoEdicao.tipo),
          id_setor: this.contatoEdicao.id_setor,
        });

        await this.getContatos();
        var contatoAtualizado = this.contatosCliente.find(
          function (x) { return x.id == this.contatoEdicao.id; }.bind(this)
        );
        if (contatoAtualizado) {
          await this.selectContato(contatoAtualizado);
        }

        this.editarContatoModal = false;
        await this.$vs.notify({
          title: "Sucesso",
          text: "Contato atualizado com sucesso.",
          color: "success",
        });
      } catch (err) {
        var error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#contactar > .con-vs-loading");
    },
    async selectContato(contato) {
      this.contatoSelected = Object.assign({}, contato);
    },
    normalizarTipoContato(tipo) {
      if (tipo === null || tipo === undefined || tipo === "") {
        return "2";
      }
      var valor = String(tipo).trim().toLowerCase();
      if (valor === "1" || valor === "email" || valor === "e-mail") {
        return "1";
      }
      if (valor === "2" || valor === "telefone" || valor === "phone") {
        return "2";
      }
      return "2";
    },
    async contactar() {
      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        var template = this.watiTemplates.find(
          function (t) { return t.id === this.templateSelecionadoId; }.bind(this)
        );
        await this.$http.post("whatsapp/enviarTemplateCobranca", {
          idConta: this.item.id,
          idContato: this.contatoSelected.id,
          templateName: template ? template.elementName : "",
          templateId: this.templateSelecionadoId,
        });

        await this.$vs.notify({
          title: "Sucesso!",
          text: "Mensagem de cobrança enviada com sucesso via WATI!",
          color: "success",
        });
        this.osModal = false;
        this.$emit("update");
      } catch (err) {
        console.log(err);
        var errorData =
          err.response && err.response.data ? err.response.data : {};
        var errorMsg = errorData.message || "Erro ao enviar mensagem.";

        var detalhe = "";
        if (errorData.errors && errorData.errors.envioMensagem) {
          detalhe = errorData.errors.envioMensagem.detalhe;
        } else if (
          Array.isArray(errorData.errors) &&
          errorData.errors.length > 0
        ) {
          detalhe = errorData.errors[0].message || "";
        } else if (typeof errorData.errors === "string") {
          detalhe = errorData.errors;
        }

        this.$vs.notify({
          title: "Erro",
          text: detalhe ? errorMsg + " (" + detalhe + ")" : errorMsg,
          color: "danger",
        });
      }
      await this.$vs.loading.close("#contactar > .con-vs-loading");
    },
  },
};
</script>
<style lang="scss" scoped>
.sk-pulse {
  background: linear-gradient(90deg, #e2e8f0 25%, #f0f4f8 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: sk-shimmer 1.4s infinite;
}
@keyframes sk-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.contactar {
  transition-duration: 50ms;

  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    background-color: #ffca00;
    color: #1f2937;
    cursor: pointer;

    .grid-view-img {
      opacity: 0.9;
    }
  }
}

.acoes-contato-topo {
  background: #f1f8ff;
  border: 1px solid #cfe8ff;
  border-radius: 8px;
  padding: 8px;
}

.acoes-contato-topo__titulo {
  font-size: 12px;
  font-weight: 700;
  color: #000;
  margin-bottom: 4px;
}

.confirmacao-texto {
  color: #334155;
  font-size: 14px;
  margin: 0;
}

#contactar {
  max-height: 75vh;
}

.contactar-modal-layout {
  display: flex;
  flex-direction: column;
  max-height: 75vh;
}

.contactar-modal-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 2px;
}

.contactar-modal-footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
  margin-top: 8px;
}

.contato-col {
  cursor: pointer;
}

/* ── Cards de contato ── */
.contato-card {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 14px 14px 12px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.15s ease;
  overflow: hidden;
}

.contato-card:hover {
  border-color: #94a3b8;
  background: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.contato-card--ativo {
  border-color: #ffca00 !important;
  background: #fffbeb !important;
  box-shadow: 0 0 0 2px rgba(255, 202, 0, 0.3);
}

.contato-card--confirmacao {
  border-color: #28c76f !important;
  background: #f0fdf4 !important;
}

.contato-card--deletado {
  opacity: 0.4;
  cursor: not-allowed;
  background: #94a3b8 !important;
}

.confirmacao-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #28c76f;
  color: white;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 0 8px 0 8px;
  display: flex;
  align-items: center;
  gap: 3px;
  letter-spacing: 0.3px;
}

.contato-card-icon {
  margin-bottom: 2px;
}

.contato-card-nome {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.contato-card-contato {
  font-size: 12px;
  color: #475569;
  font-weight: 500;
}
</style>

<style lang="scss">
.popper-select-template {
  z-index: 99999 !important;
}
.popper-editar-contato {
  z-index: 99999 !important;
}
</style>
